import { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { startJob, ensureKnown } from '../../store/knownDataSlice';
import { useNavigate } from "react-router-dom";
import StartJob from '../parts/StartJob';
import QueryDetails from '../parts/QueryDetails';
import EditQuery from '../parts/EditQuery';
import UpdatePrice from '../parts/UpdatePrice';
import FoodPackages from '../parts/FoodPackages';
import AllNotes from '../parts/AllNotes';
import PrivateNotes from '../parts/PrivateNotes';
import SaveOfferPdf from '../parts/SaveOfferPdf';



function AcceptedQueryView(props) {
    const id = useParams()["id"].toUpperCase();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const data = useSelector((state) => state.knownData[id]);

    useEffect(() => {
        dispatch(ensureKnown({ id }));
    }, []);

    if(!data) return;

    return (
        <div className="column g32 p32 screen center-cross">

            <div className="column g32" style={{ maxWidth: '100%' }}>

                <div className="column g8">
                    <div className="row g16 center-cross">
                        <h1>Kinnitatud pakkumine</h1>
                        <p>(ootab juhti ja bussi)</p>
                        {data["query_response_price"] != null && <SaveOfferPdf id={id} />}
                    </div>
                    <h2>{JSON.parse(data["query_route"]).map(route => route["city_name"]).join(" - ")}</h2>
                </div>


                <QueryDetails id={id} />

                <FoodPackages id={id} />

                <AllNotes id={id} />

                <PrivateNotes id={id} />

                <hr />

                <StartJob id={id} />

                <EditQuery id={id} />

            </div>

        </div>
    );
};

export default AcceptedQueryView;